import ExecLoop from "./data-output-generator/exec-utils/exec-loop.js";
import WaitOpFinishInstant from "./data-output-generator/exec-utils/wait-op-finish-instant.js";
import GLRaycastBuffer from "./data-output-generator/glraycaster/glraycast-buffer.js";

class GLRaycastRenderer {
    constructor(scene, camera, renderer) {
        this._renderTarget = new THREE.WebGLRenderTarget();
        this._buffer = new GLRaycastBuffer();

        this._size = { width: null, height: null };
        this._updateSize = false;

        const waitRender = new WaitOpFinishInstant();
        this._renderLoop = new ExecLoop(1000, async () => {
            const { width, height } = this._size;

            let bufData = this._buffer.data;

            if (this._updateSize) {
                this._updateSize = false;

                this._renderTarget.setSize(width, height);
                bufData = { width, height, pixels: new Uint8Array(width*height*4) };
            }

            await waitRender.execute(() => {
                renderer.render(scene, camera, this._renderTarget);
            });

            renderer.readRenderTargetPixels(this._renderTarget, 0, 0, width, height, bufData.pixels);
            this._buffer.update(bufData);
        });
    }

    get buffer() {
        return this._buffer;
    }

    start() {
        this._renderLoop.start();
    }

    stop() {
        this._renderLoop.stop();
    }

    setSize(width, height) {
        this._size.width = width;
        this._size.height = height;

        this._updateSize = true;
    }
}

export default GLRaycastRenderer;
